<template>
    <div>
        <span v-if="1 == value">
                <i class="fa fa-check green"></i>
        </span>
        <span v-else>
            <i class="fa fa-times red"></i>
        </span>
    </div>


</template>

<script>
    export default {
        name: 'np-bool',
        props: {
            value: {
                default: '-'
            }
        }
    };
</script>

<style scoped>
    .red {
        color: darkred;
    }

    .green {
        color: darkgreen;
    }
</style>
